<header class="header">
  <div class="header__left">
    <ng-content select="[headerLeft]"></ng-content>
  </div>
  <div class="header__logo">
    <ng-content select="[headerLogo]"></ng-content>
  </div>
  <div class="header__right">
    <ng-content select="[headerRight]"></ng-content>
  </div>
</header>
